import type { ActivatedDrawId } from '../../../schema/marketplace/entry.js';

export const wagerMutationKeys = {
  all: [{ scope: 'wagers' }] as const,
  placeCouponWager: (drawId: ActivatedDrawId | undefined) =>
    [{ ...wagerMutationKeys.all[0], filter: `placeCouponWager${drawId}` }] as const,
  placeExternalCouponWager: (drawId: ActivatedDrawId | undefined) =>
    [{ ...wagerMutationKeys.all[0], filter: `placeExternalCouponWager${drawId}` }] as const,
} as const;
